import { CONTACT_ATTRIBUTE_LABEL_TIME_STAMP } from "../../../constants";

interface DataGridRow {
  name: string;
  value: string;
}

interface ContactData {
  queue?: { name?: string };
  contactDuration?: unknown;
  queueTimestamp?: unknown;
  [key: string]: unknown;
}

export const getDataGridAttributes = (
  dataGridRows: DataGridRow[],
  contactData: ContactData,
  ticketOrCaseNumber: string,
): Record<string, unknown> => {
  let currentData: Record<string, unknown> = {};

  const currentAttributes = dataGridRows.filter(
    (obj) => obj.name !== CONTACT_ATTRIBUTE_LABEL_TIME_STAMP,
  );
  for (let key in currentAttributes) {
    if (currentAttributes[key].name.startsWith("Ticket")) {
      currentData[currentAttributes[key].name] = ticketOrCaseNumber;
    } else {
      currentData[currentAttributes[key].name] = currentAttributes[key].value;
    }
  }
  if (!currentData?.["Queue"] && !!contactData?.queue?.name) {
    currentData["Queue"] = contactData.queue.name;
  }
  currentData = {
    ...currentData,
    Duration: contactData.contactDuration,
    timestamp: contactData.queueTimestamp,
  };
  return currentData;
};
